var documentFilters = angular.module ( 'documentFilters' , [ ] );
documentFilters
.filter ( 'convertToRomanNumeral' , function () {
    return function romanize ( num ) {
        if ( ! + num ) {
            return false;
        }
        var digits = String ( + num ).split ( "" ) ,
            key = [ "" , "C" , "CC" , "CCC" , "CD" , "D" , "DC" , "DCC" , "DCCC" , "CM" ,
                "" , "X" , "XX" , "XXX" , "XL" , "L" , "LX" , "LXX" , "LXXX" , "XC" ,
                "" , "I" , "II" , "III" , "IV" , "V" , "VI" , "VII" , "VIII" , "IX" ] ,
            roman = "" ,
            i = 3;
        while ( i -- ) {
            roman = (key[ + digits.pop () + (i * 10) ] || "") + roman;
        }
        return new Array ( + digits.join ( "" ) + 1 ).join ( "M" ) + roman;
    }
} );

documentFilters
.filter ( 'showNumbersWhenRequired' , function () {
    return function showNumbers ( index , contents ) {
        var chapterConfig = contents.domains[ 0 ].config;
        if ( chapterConfig.hasOwnProperty ( 'startNumberingAt' ) && chapterConfig.hasOwnProperty ( 'endNumberingAt' ) ) {
            if ( index >= chapterConfig.startNumberingAt && index <= chapterConfig.endNumberingAt ) {
                index = ( index - chapterConfig.startNumberingAt + 1 ) + '. ';
                return index;
            }
        }
    }
} );

documentFilters
.filter ( 'convertStringToUrl' , function () {
    return function ( stringToConvert ) {
        var copyOfStringToConvert = stringToConvert;
        var copyOfStringToConvert = copyOfStringToConvert.replace(/[,()']/g,'');
        copyOfStringToConvert = copyOfStringToConvert.replace(/[\/–]/g,'-');
        return copyOfStringToConvert.toLowerCase().split ( ' ' ).join( '-' );
    }
} );

documentFilters
.filter ( 'convertStringToUrlForDictionary' , 
    [ '$filter', function ($filter) {
        return function ( stringToConvert ) {
            return $filter('convertStringToUrl')(stringToConvert).substring(0,50);
        }
    } ] 
);
documentFilters
.filter ( 'typeof' , function () {
    return function ( obj ) {
        return typeof obj
    };
} );
documentFilters
.filter ( 'parseint' , function () {
    return function ( string ) {
        return parseInt ( string , 10 );
    };
} );
documentFilters
.filter ( 'getNextChapter' , function () {
    return function ( array, currentChapter, increment ) {
        var currentNodeIndex = array.filter(function ( obj, index ) {
            if ( obj.chapter === currentChapter ) {
                return index;
            }
        });
        return currentNodeIndex + increment;
        
    }
} );
